export default __webpack_public_path__ + "pdf/Barbora_Kozlíková.8d4d3f2.pdf";